import React, { useEffect, useState } from "react";
import { Polyline, useMap } from "react-leaflet";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { setGoLevel4, setMapLevel } from "../../redux/map/map.actions";
import {
  selectMapLevel,
  selectMapGoLevel4,
} from "../../redux/map/map.selectors";
import {
  selectNewRequestDestLocation,
  selectNewRequestSourceLocation,
  selectNewRequestOtherDestinationsLocation,
} from "../../redux/newRequest/newRequest.selectors";

const MapLine = ({
  selectNewRequestDestLocation,
  selectNewRequestSourceLocation,
  selectNewRequestOtherDestinationsLocation,
  selectMapLevel,
  setMapLevel,

  setGoLevel4,
  selectMapGoLevel4,
}) => {
  const map = useMap();

  const [showLine, setShowLine] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowLine(true);
    }, 1000);

    // return () => {
    //   cleanup
    // }
  }, []);

  if (selectMapLevel === 2) {
    // alert("hi")
    map.flyToBounds(
      [
        [selectNewRequestDestLocation.lat, selectNewRequestDestLocation.long],
        [
          selectNewRequestSourceLocation.lat,
          selectNewRequestSourceLocation.long,
        ],
      ],
      {
        duration: 1.2,
      }
    );

    // .then(alert("hi"));
  }

  if (selectMapGoLevel4)
    setTimeout(() => {
      // alert("hi");
      // setMapLevel(3);
      setGoLevel4(false);
    }, 2000);

  //   console.log(selectNewRequestSourceLocation, selectNewRequestDestLocation);
  //   alert("hidasf");
  return (
    <>
      {showLine &&
        selectNewRequestDestLocation.lat &&
        selectNewRequestSourceLocation.lat && (
          // setTimeout(() => {
          <Polyline
            pathOptions={{ color: "#6CE3E4" }}
            positions={[
              [
                selectNewRequestSourceLocation.lat,
                selectNewRequestSourceLocation.long,
              ],
              [
                selectNewRequestDestLocation.lat,
                selectNewRequestDestLocation.long,
              ],
            ]}
          />
        )}

      {showLine &&
        selectNewRequestOtherDestinationsLocation[0]?.lat &&
        selectNewRequestDestLocation.lat && (
          <Polyline
            pathOptions={{ color: "#6CE3E4" }}
            positions={[
              [
                selectNewRequestDestLocation.lat,
                selectNewRequestDestLocation.long,
              ],
              [
                selectNewRequestOtherDestinationsLocation[0].lat,
                selectNewRequestOtherDestinationsLocation[0].long,
              ],
            ]}
          />
        )}
      {showLine &&
        selectNewRequestOtherDestinationsLocation[1]?.lat &&
        selectNewRequestOtherDestinationsLocation.map((item,index) =>
          index !== selectNewRequestOtherDestinationsLocation.length - 1 ? (
            <Polyline
              pathOptions={{ color: "#6CE3E4" }}
              positions={[
                [
                  selectNewRequestOtherDestinationsLocation[index].lat,
                  selectNewRequestOtherDestinationsLocation[index].long,
                ],
                [
                  selectNewRequestOtherDestinationsLocation[index + 1]?.lat,
                  selectNewRequestOtherDestinationsLocation[index + 1]?.long,
                ],
              ]}
            />

          ) : (
            ""
          )
        )}
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestSourceLocation: selectNewRequestSourceLocation,
  selectNewRequestDestLocation: selectNewRequestDestLocation,

  selectMapLevel: selectMapLevel,

  selectMapGoLevel4: selectMapGoLevel4,
  selectNewRequestOtherDestinationsLocation:
    selectNewRequestOtherDestinationsLocation,
});

const mapDispatchToProps = (dispatch) => ({
  setMapLevel: (x) => dispatch(setMapLevel(x)),
  setGoLevel4: (x) => dispatch(setGoLevel4(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapLine);
